import { createStore } from 'vuex'
import { mutations } from './mutations'
import actions from './actions'
import { getters } from './getters'
import parser from 'ua-parser-js'
import {landerModule} from "../lander/module/landerModule";
import {paymentModule} from "../payment/module/paymentModule";

let userAgent = parser(navigator.userAgent)

export default createStore({
  state: {
    userAgent: {
        name: userAgent.ua,
        browser: userAgent.browser.name ? userAgent.browser.name : 'unknown' ,
        deviceType: userAgent.device.type ? userAgent.device.type : 'unknown',
        os: userAgent.os.name ? userAgent.os.name : 'unknown',
    }
  },
  getters,
  actions,
  mutations,
    modules: {
        lander: landerModule,
        payment: paymentModule
    }
})
